(function () {
  function formatNumber(value, decimals) {
    if (!isFinite(value)) {
      return "-";
    }

    return Number(value)
      .toFixed(decimals)
      .replace(/\.00$/, "")
      .replace(/(\.\d*[1-9])0$/, "$1");
  }

  function polarPoint(cx, cy, radius, angleDeg) {
    var angleRad = (angleDeg * Math.PI) / 180;
    return {
      x: cx + radius * Math.cos(angleRad),
      y: cy + radius * Math.sin(angleRad)
    };
  }

  function polygonPointsString(points) {
    return points
      .map(function (pt) {
        return pt.x.toFixed(2) + "," + pt.y.toFixed(2);
      })
      .join(" ");
  }

  function shapeNameFromSides(sides) {
    var names = {
      3: "Triangle",
      4: "Square",
      5: "Pentagon",
      6: "Hexagon",
      7: "Heptagon",
      8: "Octagon",
      9: "Nonagon",
      10: "Decagon",
      12: "Dodecagon"
    };

    return names[sides] || (sides + "-sided shape");
  }

  function renderCornerDiagram(hasAngle) {
    var arcMarkup = "";

    if (hasAngle) {
      arcMarkup = '<path d="M145 150 A35 35 0 0 1 175 150" class="tms-mitre-diagram-arc"></path>';
    }

    return (
      '<svg class="tms-mitre-diagram" viewBox="0 0 320 240" role="img" aria-label="Mitre cut visual">' +
        '<path d="M80 180 L80 105 L150 105 L185 140 L185 180 Z" class="tms-mitre-diagram-board"></path>' +
        '<path d="M240 180 L170 180 L170 140 L205 105 L240 105 Z" class="tms-mitre-diagram-board"></path>' +
        arcMarkup +
      '</svg>'
    );
  }

  function renderPolygonDiagram(sides) {
    var cx = 160;
    var cy = 122;
    var radius = 72;
    var startAngle = -90;
    var points = [];
    var i;

    for (i = 0; i < sides; i += 1) {
      points.push(polarPoint(cx, cy, radius, startAngle + (360 / sides) * i));
    }

    var polygonMarkup = polygonPointsString(points);
    var targetIndex = 0;
    var prev = points[(targetIndex - 1 + sides) % sides];
    var current = points[targetIndex];
    var next = points[(targetIndex + 1) % sides];

    return (
      '<svg class="tms-mitre-diagram" viewBox="0 0 320 240" role="img" aria-label="Polygon mitre cut visual">' +
        '<polygon points="' + polygonMarkup + '" class="tms-mitre-diagram-polygon"></polygon>' +
        '<line x1="' + current.x.toFixed(2) + '" y1="' + current.y.toFixed(2) + '" x2="' + prev.x.toFixed(2) + '" y2="' + prev.y.toFixed(2) + '" class="tms-mitre-diagram-edge-highlight"></line>' +
        '<line x1="' + current.x.toFixed(2) + '" y1="' + current.y.toFixed(2) + '" x2="' + next.x.toFixed(2) + '" y2="' + next.y.toFixed(2) + '" class="tms-mitre-diagram-edge-highlight"></line>' +
        '<circle cx="' + current.x.toFixed(2) + '" cy="' + current.y.toFixed(2) + '" r="5" class="tms-mitre-diagram-polygon-corner"></circle>' +
      '</svg>'
    );
  }

  function initMitreCalculator(root) {
    if (!root || root.dataset.mitreInit === "true") {
      return;
    }

    root.dataset.mitreInit = "true";

    var form = root.querySelector(".tms-mitre-form");
    var modeButtons = root.querySelectorAll(".tms-mitre-toggle");
    var modePanels = root.querySelectorAll("[data-mode-panel]");
    var presetButtons = root.querySelectorAll("[data-angle-preset]");
    var cornerAngleInput = root.querySelector("[id*='corner-angle']");
    var sidesInput = root.querySelector("[id*='sides']");
    var messageBox = root.querySelector(".tms-mitre-message");
    var resetButton = root.querySelector("[data-action='reset']");
    var mitreAngleOutput = root.querySelector("[data-result='mitre-angle']");
    var jointAngleOutput = root.querySelector("[data-result='joint-angle']");
    var piecesOutput = root.querySelector("[data-result='pieces-at-joint']");
    var explanationOutput = root.querySelector("[data-result='explanation']");
    var diagramModeLabel = root.querySelector("[data-diagram-mode-label]");
    var diagramHost = root.querySelector("[data-mitre-diagram-host]");
    var diagramShape = root.querySelector("[data-diagram-shape]");
    var diagramJoint = root.querySelector("[data-diagram-joint]");
    var diagramCut = root.querySelector("[data-diagram-cut]");
    var currentMode = "angle";

    function clearMessage() {
      if (!messageBox) {
        return;
      }

      messageBox.textContent = "";
      messageBox.className = "tms-mitre-message";
    }

    function showError(text) {
      if (!messageBox) {
        return;
      }

      messageBox.textContent = text;
      messageBox.className = "tms-mitre-message is-error";
    }

    function showSuccess(text) {
      if (!messageBox) {
        return;
      }

      messageBox.textContent = text;
      messageBox.className = "tms-mitre-message is-success";
    }

    function setDiagramMarkup(markup) {
      if (!diagramHost) {
        return;
      }

      diagramHost.innerHTML = markup;
    }

    function updateDiagramMeta(shapeText, jointText, cutText) {
      if (diagramShape) {
        diagramShape.textContent = shapeText;
      }

      if (diagramJoint) {
        diagramJoint.textContent = jointText;
      }

      if (diagramCut) {
        diagramCut.textContent = cutText;
      }
    }

    function resetDiagram(mode) {
      if (diagramModeLabel) {
        diagramModeLabel.textContent = mode === "angle" ? "Corner joint view" : "Shape corner view";
      }

      if (mode === "angle") {
        setDiagramMarkup(renderCornerDiagram(false));
        updateDiagramMeta("Corner joint", "-", "-");
      } else {
        setDiagramMarkup(renderPolygonDiagram(5));
        updateDiagramMeta("Pentagon", "108 deg", "54 deg");
      }
    }

    function setMode(mode) {
      currentMode = mode;

      modeButtons.forEach(function (button) {
        var isActive = button.getAttribute("data-mode-target") === mode;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });

      modePanels.forEach(function (panel) {
        var shouldShow = panel.getAttribute("data-mode-panel") === mode;
        panel.classList.toggle("is-hidden", !shouldShow);
      });

      resetDiagram(mode);
      clearMessage();
    }

    function renderResults(mitreAngle, jointAngle, explanationText) {
      if (mitreAngleOutput) {
        mitreAngleOutput.textContent = formatNumber(mitreAngle, 2) + " deg";
      }

      if (jointAngleOutput) {
        jointAngleOutput.textContent = formatNumber(jointAngle, 2) + " deg";
      }

      if (piecesOutput) {
        piecesOutput.textContent = "2";
      }

      if (explanationOutput) {
        explanationOutput.textContent = explanationText;
      }
    }

    function calculateFromCornerAngle() {
      if (!cornerAngleInput) {
        return;
      }

      var rawValue = cornerAngleInput.value.trim();

      if (!rawValue) {
        showError("Please enter a finished corner angle.");
        cornerAngleInput.focus();
        return;
      }

      var cornerAngle = parseFloat(rawValue);

      if (isNaN(cornerAngle)) {
        showError("Please enter a valid number for the corner angle.");
        cornerAngleInput.focus();
        return;
      }

      if (cornerAngle <= 0 || cornerAngle >= 180) {
        showError("Corner angle must be more than 0 and less than 180 degrees.");
        cornerAngleInput.focus();
        return;
      }

      var mitreAngle = cornerAngle / 2;

      renderResults(
        mitreAngle,
        cornerAngle,
        "For a finished corner angle of " +
          formatNumber(cornerAngle, 2) +
          " deg, each of the two mating pieces should be cut at " +
          formatNumber(mitreAngle, 2) +
          " deg."
      );

      if (diagramModeLabel) {
        diagramModeLabel.textContent = "Corner joint view";
      }

      setDiagramMarkup(renderCornerDiagram(true));
      updateDiagramMeta("Corner joint", formatNumber(cornerAngle, 2) + " deg", formatNumber(mitreAngle, 2) + " deg");
      showSuccess("Calculation complete.");
    }

    function calculateFromSides() {
      if (!sidesInput) {
        return;
      }

      var rawValue = sidesInput.value.trim();

      if (!rawValue) {
        showError("Please enter the number of equal sides.");
        sidesInput.focus();
        return;
      }

      if (!/^\d+$/.test(rawValue)) {
        showError("Number of sides must be a whole number.");
        sidesInput.focus();
        return;
      }

      var sides = parseInt(rawValue, 10);

      if (isNaN(sides) || sides < 3) {
        showError("A regular shape must have at least 3 sides.");
        sidesInput.focus();
        return;
      }

      var interiorAngle = ((sides - 2) * 180) / sides;
      var mitreAngle = interiorAngle / 2;

      renderResults(
        mitreAngle,
        interiorAngle,
        "A regular " +
          sides +
          "-sided shape has an interior angle of " +
          formatNumber(interiorAngle, 2) +
          " deg. Each piece should be cut at " +
          formatNumber(mitreAngle, 2) +
          " deg to form the joint."
      );

      if (diagramModeLabel) {
        diagramModeLabel.textContent = "Shape corner view";
      }

      setDiagramMarkup(renderPolygonDiagram(sides));
      updateDiagramMeta(shapeNameFromSides(sides), formatNumber(interiorAngle, 2) + " deg", formatNumber(mitreAngle, 2) + " deg");
      showSuccess("Calculation complete.");
    }

    function resetCalculator() {
      if (cornerAngleInput) {
        cornerAngleInput.value = "";
      }

      if (sidesInput) {
        sidesInput.value = "";
      }

      if (mitreAngleOutput) {
        mitreAngleOutput.textContent = "-";
      }

      if (jointAngleOutput) {
        jointAngleOutput.textContent = "-";
      }

      if (piecesOutput) {
        piecesOutput.textContent = "2";
      }

      if (explanationOutput) {
        explanationOutput.textContent =
          "Enter a corner angle or number of sides, then click Calculate to see the correct mitre cut for each piece.";
      }

      clearMessage();
      setMode("angle");

      if (cornerAngleInput) {
        cornerAngleInput.focus();
      }
    }

    presetButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var presetValue = button.getAttribute("data-angle-preset");

        if (cornerAngleInput) {
          cornerAngleInput.value = presetValue;
          cornerAngleInput.focus();
        }

        clearMessage();
      });
    });

    modeButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setMode(button.getAttribute("data-mode-target"));
      });
    });

    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        clearMessage();

        if (currentMode === "angle") {
          calculateFromCornerAngle();
        } else {
          calculateFromSides();
        }
      });
    }

    if (resetButton) {
      resetButton.addEventListener("click", function () {
        resetCalculator();
      });
    }

    if (cornerAngleInput) {
      cornerAngleInput.addEventListener("input", clearMessage);
    }

    if (sidesInput) {
      sidesInput.addEventListener("input", clearMessage);
    }

    setMode("angle");
  }

  function initAllMitreCalculators(scope) {
    var context = scope || document;
    var calculators = context.querySelectorAll("[data-tool='mitre-angle-calculator']");

    calculators.forEach(function (calculator) {
      initMitreCalculator(calculator);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllMitreCalculators(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllMitreCalculators(event.target);
  });
})();